angular.module('unica_media_directory.media_directory_services')

.factory('MediaDirectoryEditService', function ($http, getBaseApiURL) {

	var mediaDirectoryEditService = {};

	mediaDirectoryEditService.update = function (mediaDirectoryData) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/media-directory/update/' + mediaDirectoryData.id,
			data: mediaDirectoryData
		}).then(function(result) {

			if ( result ) {
				return result.data.directory;
			}

		});

	};

	return mediaDirectoryEditService;
});